import React, { useEffect, useMemo, useRef } from "react";

export default function TelosPrelude() {
  const scenes = useMemo(
    () => [
      { type: "normal", lines: ["This is an ancient story"] },
      { type: "blank" },

      { type: "normal", lines: ["that began long before you arrived."] },
      { type: "blank" },

      { type: "normal", lines: ["Countless love stories have been told."] },
      { type: "blank" },

      { type: "normal", lines: ["Countless more lives have come and gone."] },
      { type: "blank" },

      {
        type: "normal",
        lines: ["This is your chance,", "to experience one of these lives,"],
      },

      { type: "shortPause" },
      { type: "here" },
      { type: "ampersand" },
      { type: "now" },
      { type: "shortPause" },

      { type: "normal", lines: ["Will you join this never-ending story?"] },
      { type: "blank" },
    ],
    []
  );

  const hereWrapRef = useRef(null);
  const ampersandWrapRef = useRef(null);
  const nowWrapRef = useRef(null);

  const hereTextRef = useRef(null);
  const ampersandTextRef = useRef(null);
  const nowTextRef = useRef(null);

  useEffect(() => {
    const hereWrap = hereWrapRef.current;
    const ampersandWrap = ampersandWrapRef.current;
    const nowWrap = nowWrapRef.current;

    const hereEl = hereTextRef.current;
    const ampersandEl = ampersandTextRef.current;
    const nowEl = nowTextRef.current;

    if (!hereWrap || !ampersandWrap || !nowWrap || !hereEl || !ampersandEl || !nowEl) return;

    const clamp01 = (n) => Math.max(0, Math.min(1, n));

    const HERE_FADE_RADIUS = 360;
    const AMPERSAND_FADE_RADIUS = 340;
    const NOW_FADE_RADIUS = 320;

    const computeOpacity = (wrapEl, radiusPx) => {
      const rect = wrapEl.getBoundingClientRect();
      const centerY = window.innerHeight * 0.5;
      const sceneCenter = rect.top + rect.height * 0.5;
      const dist = Math.abs(sceneCenter - centerY);
      return clamp01(1 - dist / radiusPx);
    };

    const tick = () => {
      hereEl.style.opacity = String(computeOpacity(hereWrap, HERE_FADE_RADIUS));
      ampersandEl.style.opacity = String(
        computeOpacity(ampersandWrap, AMPERSAND_FADE_RADIUS)
      );
      nowEl.style.opacity = String(computeOpacity(nowWrap, NOW_FADE_RADIUS));
    };

    tick();

    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(tick);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div>
      {scenes.map((scene, index) => {
        if (scene.type === "blank") {
          return (
            <div key={index} className="phrase-container fullHeight">
              <div className="row">
                <h1>&nbsp;</h1>
              </div>
            </div>
          );
        }

        if (scene.type === "longPause") {
          return <div key={index} className="long-pause" />;
        }

        if (scene.type === "shortPause") {
          return <div key={index} className="short-pause" />;
        }

        if (scene.type === "here") {
          return (
            <div key={index} ref={hereWrapRef} className="phrase-container fullHeight">
              <div className="row">
                <h1>
                  <span ref={hereTextRef} className="scroll-fade-simple emphasis-text">
                    Here
                  </span>
                </h1>
              </div>
            </div>
          );
        }

        if (scene.type === "ampersand") {
          return (
            <div
              key={index}
              ref={ampersandWrapRef}
              className="phrase-container fullHeight"
            >
              <div className="row">
                <h1>
                  <span
                    ref={ampersandTextRef}
                    className="scroll-fade-simple emphasis-text ampersand"
                  >
                    &amp;
                  </span>
                </h1>
              </div>
            </div>
          );
        }

        if (scene.type === "now") {
          return (
            <div key={index} ref={nowWrapRef} className="phrase-container fullHeight">
              <div className="row">
                <h1>
                  <span ref={nowTextRef} className="scroll-fade-simple emphasis-text">
                    Now
                  </span>
                </h1>
              </div>
            </div>
          );
        }

        return (
          <div key={index} className="phrase-container fullHeight">
            <div className="row">
              {scene.lines.map((line, idx) => (
                <h1 key={idx}>{line}</h1>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}